module.exports = __webpack_public_path__ + "static/media/Phone.fd413b30.png";